import {
  Button,
  Input,
  Select,
  HStack,
  VStack,
  Box,
  Text,
  useToast,
  InputGroup,
  InputRightElement
} from '@chakra-ui/react';
import { FaTruckMoving } from "react-icons/fa";
import { useForm } from 'react-hook-form';
import { BoxTitle } from '@/components/BoxTitle';
import { ModalAlert } from '@/components/ModalStyled/Modal';


interface AgendamentoFormData {
  janela: string;
  tipoJanela: string;
  fabrica: string;
  inicio: string;
  fim: string;
}

interface ModalAgendamentoProps {
  isOpen: boolean;
  onClose: () => void;
  handleAddAgendamento: (formData: AgendamentoFormData) => void;
}

const ModalAgendamento: React.FC<ModalAgendamentoProps> = ({ isOpen, onClose, handleAddAgendamento }) => {
  const toast = useToast();
  const {
    handleSubmit,
    setValue,
    watch,
    reset
  } = useForm<AgendamentoFormData>({
    defaultValues: {
      janela: '',
      tipoJanela: '',
      fabrica: '',
      inicio: '',
      fim: ''
    }
  });

  const onSubmit = async (data: AgendamentoFormData) => {
    const missingFields: any = [];

    Object.entries(data).forEach(([key, value]) => {
      if (!value) missingFields.push(key);
    });

    if (missingFields.length > 0) {
      toast({
        title: missingFields.length === 1
          ? `O campo ${missingFields[0]} é obrigatório.`
          : "Faltam campos obrigatórios a serem preenchidos.",
        status: "error",
        isClosable: true,
      });
      return;
    }

    handleAddAgendamento(data);
    toast({
      title: "Agendamento adicionado com sucesso!",
      status: "success",
      isClosable: true,
    });
    reset();
    onClose();
  };

  return (
    <ModalAlert
      isOpen={isOpen}
      onClose={onClose}
      size='3xl'
      title={<Text fontSize={'xl'} ml={2}>Agendamento</Text>}
      body={
        <Box as="form" onSubmit={handleSubmit(onSubmit)}>
          <VStack spacing={4} align="stretch">
            <HStack>
              <BoxTitle title="Janela">
                <Input value={watch("janela")} onChange={(e) => setValue("janela", e.target.value)} placeholder="Adicione uma janela" />
              </BoxTitle>
              <BoxTitle title="Tipo Janela">
                <Select value={watch("tipoJanela")} onChange={(e) => setValue("tipoJanela", e.target.value)} placeholder="Selecione janela" />
              </BoxTitle>
            </HStack>
            <BoxTitle title="Fabrica">
              <Select value={watch("fabrica")} onChange={(e) => setValue("fabrica", e.target.value)} placeholder="Selecione uma fábrica" />
            </BoxTitle>
            <HStack>
              <BoxTitle title="Início">
                <InputGroup>
                  <Input value={watch("inicio")} onChange={(e) => setValue("inicio", e.target.value)} placeholder="Digite uma hora início" />
                  <InputRightElement>

                  </InputRightElement>
                </InputGroup>
              </BoxTitle>
              <BoxTitle title="Fim">
                <InputGroup>
                  <Input value={watch("fim")} onChange={(e) => setValue("fim", e.target.value)} placeholder="Digite uma hora fim" />
                  <InputRightElement>

                  </InputRightElement>
                </InputGroup>
              </BoxTitle>
            </HStack>
          </VStack>
        </Box>
      }
      footer={
        <Button colorScheme="blue" onClick={handleSubmit(onSubmit)}>
          Confirmar
        </Button>
      }
    />
  );
};

export default ModalAgendamento;
